import { useDispatch, useSelector } from "react-redux";

import {
  selectCanApproveVariance,
  selectCanClearExecution,
  selectCanEditExecution,
  selectCanRecordExecution,
  selectCanReleaseHold,
  selectCanWrite,
  selectIsAdmin,
  selectUser,
} from "@/app/authSlice";
import { selectUnit, selectUnitName } from "@/app/unitSlice";

export { useApi, useAction, useJobPolling, notifyError } from "./useApi";
export { useEditableConfig } from "./useEditableConfig";
export { useShowOnBoard, SHOW_ON_BOARD_HINT } from "./useShowOnBoard";
export { useLivePlan } from "./useLivePlan";
export { usePlanningLocks } from "./usePlanningLocks";

/** The production unit every page scopes its requests to. */
export const useUnit = () => useSelector(selectUnit);
export const useUnitName = () => useSelector(selectUnitName);

export const useCurrentUser = () => useSelector(selectUser);
/** Mirrors the server's RBAC so the UI hides actions it would reject. */
export const useCanWrite = () => useSelector(selectCanWrite);
export const useIsAdmin = () => useSelector(selectIsAdmin);
/** Supervisors may record execution data even though other writes are closed. */
export const useCanEditExecution = () => useSelector(selectCanEditExecution);
/** Entering a new actual — the `create` half of the execution grant. */
export const useCanRecordExecution = () => useSelector(selectCanRecordExecution);
/** Clearing or re-pulling the feed — destructive, so its own `delete` grant. */
export const useCanClearExecution = () => useSelector(selectCanClearExecution);
/** QA signs off variance investigations — its one write. */
export const useCanApproveVariance = () => useSelector(selectCanApproveVariance);
/** Releasing a QA hold: QA tiers and the administrator only. */
export const useCanReleaseHold = () => useSelector(selectCanReleaseHold);

export { useDispatch, useSelector };

export { usePermission } from "./usePermission";
